import axios from "axios";
import Cookies from "js-cookie";
class GameReportService {
  constructor(baseURL) {
    this.api = axios.create({
      baseURL: baseURL || "https://api.gastonbet365.com/",
    });
  }

  async getAllGameReports(query) {
    try {
      const token = Cookies.get("token");
      const response = await this.api.get(
        `/hr/gaming-report?startDate=${query?.startDate}&endDate=${query?.endDate}${query.query}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return {
        success: true,
        status: response.status,
        reports: response.data.data,
      };
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de tous les utilisateurs :",
        error
      );
      if (error.response) {
        return {
          success: false,
          status: error.response.status,
          message:
            error.response.data.message ||
            "Une erreur est survenue lors de la récupération des utilisateurs",
        };
      } else {
        return {
          success: false,
          status: 500,
          message: "Network error or server is unreachable.",
        };
      }
    }
  }
}
export default GameReportService;
